import { notifications } from "@mantine/notifications";
import { FailedToNegotiateWithServerError } from "@microsoft/signalr/dist/esm/Errors";
import {createSlice} from "@reduxjs/toolkit";
import { current } from '@reduxjs/toolkit'
import { clear, Console } from "console";
import intl from "react-intl-universal";
//import type { PayloadAction } from '@reduxjs/toolkit'



const initialState = {
  connected: false,
  iskicked: false,
  guestconnected: false,
  hostforguestisonline: false,
  signtabopen: false,
  signisstapel: false,
  setupmodalstapelopen: null as string | null | boolean,
  isadhocsign: false,
  signisstapelid: "",
  readdocnotaronly: "",
  initsync: false,
  inithasloaded: false,
  initdochasloaded: false,
  wsconnectederror: false,
  setupnotar: false,
  showonlinebar: true,
  meetingclosed: false,
  temppdfurl: "",
  temppdfurlresid: "",
  token: "",
  cmslink: [] as any,
  displaytyp: 1,
  displaywidth: 1,
  meetinginfo: [] as any,
  meetingszenen: [] as any,
  meuser: [] as any,
  meetinguser:[] as any,
  meetingdocs: [] as any,
  meetingdocspreparestatus: [] as any,
  userhavetostapelsigndocs: [] as any,
  userhavechangestapel: false,
  showmeetingdocs:[] as any,
  showsignmeetingdocs:[] as any,
  showsignmeetingdocsstapel:[] as any,
  identscreenshots: [] as any,
  startscreenshot: false,
  newscreenshot: false,
  newscreenshotid: "",
  userhavetosigndocs: [] as any,
  userhavetoident: [] as any,
  meetinglogs: [] as any,
  showlogs: false,
  szenetyp: "",
  usertype: "",
  activconfirmuser: "",
  leftmeeting: false,
  signprozess: false,
  accinProgress: "",
  updatemeetingdate: false,
  clientlanguage: "de_DE",
  changelanguage: false,
  notarhastosign: false,
  screeshoterror: "",
  idAustriadataloading: [] as any,
  klientidAustriaaccept: [] as any,
  idAustriadata: [] as any,
  cmslinkfirstName: "",
  cmslinklastName: "",
  docsconvertinprogress: [] as any,
  externclosevk: false,
  usertosignsent: false,
  guest_meetinginfo: [] as any,
  guest_meeting_participants: [] as any,
  guest_meinfo: [] as any,
  guest_documents: [] as any,
  guest_isValid: undefined as any,
  guest_joinlink:[] as any,
  guest_leftmeeting: false,
  guest_notarleftmeeting: false,
  guest_notactive: false,
  guest_already_inmeeting: false,
  guest_accsses_denied: false,
  guest_has_removed: false,
  guest_DocumentOneTimeLink: null as any,
  playsound: false,
  test_data: [] as any,
  test_userleave_cms: false,
  help_audio_clicked: false,
  adduseriframelink: "",
  }

export const mainSlice = createSlice({
    name: "mainSlice",
    initialState,
    reducers: {
      connect: (state) => {
        state.connected = true;
      },
      guestconnect: (state) => {
        state.guestconnected = true;
      },

      disconnect: (state) => {
        state.connected = false;
      },

      connecterror: (state,param) => {
        const { payload } = param
        state.wsconnectederror = true;
        //console.log("Websocket connection error");
        if (payload.message?.includes('maximum message size')) {
        notifications.show({
            title: intl.get('NOTIF_ERROR_HEADER'),
            message: payload.message,
            withCloseButton: false,
            autoClose: false,
            color: 'red',
            })
          }
        


      },
      /**
       * Get the token and assign it to the state.
       *
       * @param {type} state - the state object
       * @param {type} param - the parameter object
       * @return {type} undefined
       */
      gettoken: (state, param) => {
        const { payload } = param
        state.token = payload
      },
      /**
       * Sets the client language in the state.
       * changed changelanguage for display diffrent rejoin Button Message
       *
       * @param {object} param - The parameter object containing the payload
       * 
       */
      setclientlanguage: (state, param) => {
        const { payload } = param
        //console.log("setclientlanguage", payload)
        state.clientlanguage = payload
        state.changelanguage = true
        state.cmslink = []
        //console.log("state.changelanguage", state.changelanguage)
      },
      /**
       * Indicates that the client language has been changed for display diffrent rejoin Button Message.
       *
       * @param {type} state - description of parameter
       * 
       */
      clear_setclientlanguage: (state) => {
        state.changelanguage = false
      },

      // HAndle Sign Tab Open State

      set_signtabopen: (state) => {
        state.signtabopen = true
        state.readdocnotaronly = ""
        state.isadhocsign = false
      },
      
      clear_signtabopen: (state) => {
       console.log("clear_signtabopen")
        state.signtabopen = false
        state.readdocnotaronly = ""
      },

      set_signisstapel: (state,param) => {
        const { payload } = param
        //console.log("set_signisstapel", payload)
        state.temppdfurl = payload.tempurl
        state.signisstapel = true
        state.signprozess = true
        state.signisstapelid = payload.stapelId
        state.readdocnotaronly = ""
      },
      
      clear_signisstapel: (state) => {
       console.log("clear_signisstapel")
        state.signisstapel = false
        state.accinProgress = "Unterschriften"
        state.readdocnotaronly = ""
        state.signisstapelid = ""
        state.temppdfurl = ""
      },

      set_isadhocsign: (state) => {
        console.log("set_isadhocsign")
        state.isadhocsign = true
      },


      read_doc_notaronly: (state, param) => {
        const { payload } = param
        state.readdocnotaronly = payload
        state.showmeetingdocs = []
      },

      clear_read_doc_notaronly: (state) => {
        state.readdocnotaronly = ""
        state.isadhocsign = false
      },

      set_modal_stapel_setup_open: (state, param) => {
        const { payload } = param
        //console.log("set_modal_stapel_setup_open", payload)
        state.setupmodalstapelopen = payload
      },

      clear_modal_stapel_setup_open: (state) => {
        state.setupmodalstapelopen = false
      },

      /**
       * Inficates that the DatenSync on Startup is finished
       *
       * @param {Object} state 
       * @param {Object} param 
       * @param {any} param.payload - The payload to be set
       *  
       */
      set_syncisdone: (state) => {
        state.initsync = true
      },

      /**
       * Inficates that the notar has done setup or not
       *
       * @param {Object} state 
       * @param {Object} param 
       * @param {any} param.payload - The payload to be set
       *  
       */
      setsetupnotar: (state, param) => {
        const { payload } = param
        //console.log("Hit setsetupnotar", payload )
        state.setupnotar = payload
      },

            /**
       * Inficates to show isonlinebar or not
       *
       * @param {Object} state 
       * @param {Object} param 
       * @param {any} param.payload - The payload to be set
       *  
       */
      handleonlinebar: (state, param) => {
          const { payload } = param
          state.showonlinebar = payload
      },


      /**
       * Used to set the displaytyp property in the state object.
       *
       * @param {type} state 
       * @param {type} param 
       * 
       */
      setdisplaytyp: (state, param) => {
        const { payload } = param
        state.displaytyp = payload
      },
      /**
       * Set the display width in the state.
       *
       * @param {object} param - The parameter object containing the payload
       * @return {void} 
       */
      setdisplaywidth: (state, param) => {
        const { payload } = param
        state.displaywidth = payload
      },
      /**
       * A description of the entire function.
       *
       * @param {type} param - description of parameter
       * @return {type} description of return value
       */
      setszenetyp: (state, param) => {
        const { payload } = param
        state.szenetyp = payload
      },
      setusertype: (state, param) => {
        const { payload } = param
        state.usertype = payload
      },
      setcmslink: (state, param) => {
        const { payload } = param
        //console.log(payload)
        //console.log(payload.notarialErrorCode)
        const readdocsArray:any = Object.values(payload.documents);
        const participantsArray:any = Object.values(payload.meeting.meetingParticipants);

  
   
        state.cmslink = payload
        state.usertype = payload.role
        state.meetinginfo = payload.meeting
        state.meetingdocs = payload.documents
        state.meuser = payload.me
        state.meetinguser = payload.meeting.meetingParticipants
        state.meetingszenen = payload.scenesOrder

        if (payload.meeting.stapels) {
          state.userhavetostapelsigndocs = payload.meeting.stapels
        }

        //Init CMS Linkvariablen
        state.cmslinkfirstName = payload.me.firstName
        state.cmslinklastName = payload.me.lastName
        
        // Lese Initiale Signers Daten
        // eslint-disable-next-line array-callback-return, @typescript-eslint/no-unused-vars
        const initsingners = (payload.documents || []).map((data:any, index:any) => {
          if (data.signers.length !== 0){
            const user_to_docs = {
              resourceId: data.resourceId,
              isSigPrepared: data.isSigPrepared,
              user: data.signers
            };
            state.userhavetosigndocs.push(user_to_docs);
          }
        })

        if (participantsArray.length >= 1){
          state.inithasloaded = true
        }
        if (readdocsArray.length >= 1){
          state.initdochasloaded = true
          state.setupnotar = true
        }
      },

      updatedataonchangeinDRN: (state, param) => {
        const { payload } = param
        const participantsArray:any = Object.values(payload.meetingParticipants);
        state.meetinguser = participantsArray
       
      }, 


      setrejoincmslink: (state, param) => {
        const { payload } = param
        state.cmslink = payload
        state.leftmeeting = false
      },
      
      
      update_UserData: (state, param) => {
        const { payload } = param
        const updateuserdata:any = state.meetinguser.find((item:any) => item.id === payload.id)
        //console.log(payload.meetingParticipantStatus)
        // Update User participants
        if (updateuserdata) {
         // console.log(payload.meetingParticipantStatus)
          

          if (payload.meetingParticipantStatus === "LeftMeeting" && updateuserdata.meetingParticipantStatus !== "LeftMeeting") {
          notifications.show({
            title: intl.get('GUESTMESSAGE_LEFTMEETING_HEAD'),
            message:  updateuserdata.firstName + " " + updateuserdata.lastName + " " + intl.get('GUESTMESSAGE_LEFTMEETING_CONTENT'),
            withCloseButton: false,
            autoClose: 4000,
            color: 'red',
            })
            state.playsound = true
        }

        if (payload.meetingParticipantStatus === "InMeeting" && updateuserdata.meetingParticipantStatus !== "InMeeting") {
          notifications.show({
            title: intl.get('GUESTMESSAGE_JOINMEETING_HEAD'),
            message: updateuserdata.firstName + ' ' + updateuserdata.lastName + ' ' + intl.get('GUESTMESSAGE_JOINMEETING_CONTENT'),
            withCloseButton: false,
            autoClose: 3000,
            color: 'green',
            })
            state.playsound = true
        }

        updateuserdata.meetingParticipantStatus = payload.meetingParticipantStatus
      }
      },

      update_Meeting_UserStatus: (state, param) => {
        const { payload } = param
        if (payload.meetingParticipantStatus === "LeftMeeting" && state.meuser.id === payload.id){
            state.leftmeeting = true
            state.cmslink = []  
         }
        //console.log(state.leftmeeting)
      },

      /**
       * Update the meetinglist with Guestdata if the user is not on the list
       *
       * @param {type} param - description of parameter
       * @return {type} description of return value
       */

      update_InviteGuestforVK: (state, param) => {
        const { payload } = param
       // console.log(payload)

       if (payload.notarialErrorCode === undefined){

        const updateinviteuserdata:any = state.meetinguser.find((item:any) => item.id === payload.id)
        //console.log( current(updateinviteuserdata))

        if (!updateinviteuserdata) {
          // If user doesn't exist, add them to meetinguser array
           state.meetinguser.push(payload);

           notifications.show({
            title: intl.get('GUESTMESSAGE_JOINMEETING_HEAD'),
            message: payload.userId + " wurde in das Meeting aufgenommen",
            withCloseButton: false,
            autoClose: 3000,
            color: 'green',
            })
            state.playsound = true
        }
       } else {
        notifications.show({
          title: intl.get('GUESTMESSAGE_LEFTMEETING_HEAD'),
          message: payload.description,
          withCloseButton: false,
          autoClose: 4000,
          color: 'red',
          })
          state.playsound = true 
       }


 
      },

      remove_InviteGuestforVK: (state, param) => {
        const { payload } = param
        //console.log(payload)
       // const updateinviteuserdata:any = state.meetinguser.find((item:any) => item.id === payload.id)
        const userIndex = state.meetinguser.findIndex((item: any) => item.id === payload.id);
        //console.log( current(updateinviteuserdata))

        if (userIndex !== -1) {
          state.meetinguser.splice(userIndex, 1); 
          notifications.show({
            title: intl.get('GUESTMESSAGE_LEFTMEETING_HEAD'),
            message: payload.userId + " wurde als Gast aus dem MNetting entfernt",
            withCloseButton: false,
            autoClose: 3000,
            color: 'green',
            })
            state.playsound = true
        } else {
          // If user doesn't exist, add them to meetinguser array
           notifications.show({
            title: intl.get('GUESTMESSAGE_JOINMEETING_HEAD'),
            message: payload.userId + " wurde nicht in der Gastliste gefunden",
            withCloseButton: false,
            autoClose: 4000,
            color: 'red',
            })
            state.playsound = true
        }
      },




      update_confirm_UserData: (state, param) => {
        const { payload } = param
       // console.log(payload)
        const updateuseractiondata:any = state.meetinguser.find((item:any) => item.id === payload.id)
        if (updateuseractiondata) {
          updateuseractiondata.actions = payload.actions
        }
       // console.log(current(updateuseractiondata))
      },

      setactiveconfirmuser: (state, param) => {
        const { payload } = param
        state.activconfirmuser = payload
      },
      clearactiveconfirmuser: (state) => {
        state.activconfirmuser = ""
      },

      update_Prepare_Docs: (state, param) => {
        const { payload } = param
        //console.log(payload.documents)
        //console.log(state.meuser.role)
        if (payload.notarialErrorCode === undefined){
          
          // Rückwärts Kompatibilität Stapel 
          if (payload.documents && payload.documents.length > 0) {
            state.meetingdocs = payload.documents;
          } else if (payload.documents === undefined || payload.documents.length === 0) {
            state.meetingdocs = payload;
          }


          // Prevent Racing Condition with Notar setup
          if (state.userhavechangestapel === false){
            //console.log("payload.stapels",payload.stapels)
          state.userhavetostapelsigndocs = payload.stapels
          }
        } else {
          notifications.show({
            title: intl.get('NOTIF_ERROR_HEADER'),
            message: intl.get('BackendServerUnavailable'),
            withCloseButton: true,
            autoClose: false,
            color: 'red',
          })
        }
      }, 

      update_SetDoc_Readout: (state, param) => {
        const { payload } = param
        //console.log(payload.documents)
        state.meetingdocs = payload.documents
        //console.log(state.leftmeeting)
      },

      update_SetDoc_isSignedByAll: (state, param) => {
        const { payload } = param
        //console.log(payload.documents)
        state.meetingdocs = payload.documents
        //console.log(state.leftmeeting)
      },

      update_Docs_Status: (state, param) => {
        const { payload } = param
        console.log(payload.DocumentEvent)
        const readdocsArray:any = Object.values(payload.documents);

        // ADD ONLY OPENE SETUPS ON GIVEN STANCES
        // DocumentUploaded
        // DocumentMovedToFolder
 
        if (readdocsArray.length >= 1){
        state.meetingdocs = payload.documents
        state.inithasloaded = true
        state.setupnotar = true
        } 
      },

      refresh_Docs: (state, param) => {
        const { payload } = param
         if (payload.notarialErrorCode === undefined){
        state.meetingdocs = payload.documents
        state.initsync = true
        state.setupnotar = true
         } else { 
          notifications.show({
          title: payload.notarialErrorCode,
          message: payload.description,
          withCloseButton: true,
          autoClose: false,
          color: 'red',
        }) 
         }
       
      },


      refresh_Docs_onUpdate_CloseModal: (state) => {
         state.setupnotar = false
      },


      
      refresh_Docs_onUpdate: (state, param) => {
        const { payload } = param
       // console.log(payload)
        //console.log("refresh_Docs_onUpdate",payload.meetingModel.meetingParticipants)
        state.meetingdocs = payload.meetingModel.documents
        state.meetinguser = payload.meetingModel.meetingParticipants
        state.userhavetostapelsigndocs = payload.meetingModel.stapels
        state.initsync = true

        //console.log(state.temppdfurlresid)
        if (state.temppdfurlresid !== "" && payload.documentEvent === "DocumentDeleted"){  
          const updateuserdocumentsdata:any = state.meetingdocs.find((item:any) => item.resourceId === state.temppdfurlresid)
          //console.log(updateuserdocumentsdata)
        if (!updateuserdocumentsdata) {
          state.temppdfurlresid = "";
          state.temppdfurl = "";
          notifications.show({
          title: intl.get('NOTIF_ERROR_HEADER'),
          message: "Dokument wurde im DRN gelöscht. Das Dokumentfenster wird geschlossen.",
          withCloseButton: true,
          autoClose: false,
          color: 'red',
        })
        }

        }

        if (payload.documentEvent === "DocumentDeleted" && state.setupnotar === true){
          state.setupnotar = true
        }

        if (payload.documentEvent === "DocumentDataChanged" && state.setupnotar === true){
          state.setupnotar = true
        }

        // ADD ONLY OPENE SETUPS ON GIVEN STANCES
        // DocumentUploaded
        // DocumentMovedToFolder
        if (payload.documentEvent === "DocumentUploaded" || payload.documentEvent === "DocumentMovedToFolder"){
          state.setupnotar = true
        }
       
      },




      update_DocsSign_Status: (state, param) => {
        const { payload } = param
       // console.log(payload)
        const updateuserdocumentsdata:any = state.meetinguser.find((item:any) => item.id === payload.id)
        if (updateuserdocumentsdata) {
          updateuserdocumentsdata.documents = payload.documents
        }
      },

      update_DocsSignStapel_Status: (state, param) => {
        const { payload } = param
        const index = state.userhavetostapelsigndocs.findIndex((item: { id: any; }) => item.id === payload.stapel.id);
        if (index !== -1) {
          // Update the state DIRECTLY using Immer's "mutating" style
          state.userhavetostapelsigndocs[index] = payload.stapel;
          //console.log(current(state.userhavetostapelsigndocs)); // Log the updated state
          } else {
          console.log("Stapel entry not found."); // Handle the case where the entry is not found
        }
      },


      update_DocsPrepareTemp_Status: (state, param) => {
        const { payload } = param

        //console.log("update_DocsPrepareTemp_Status:",payload)
         
        const index = state.meetingdocspreparestatus.findIndex(
          (item:any) => item.resourceId === payload.resourceId
        );

       if (index !== -1) {
        state.meetingdocspreparestatus[index] = payload;
        //console.log("update",payload)
      } else {
        state.meetingdocspreparestatus.push(payload);
        //console.log("push",payload)
      }




      },

      remove_DocsPrepareTemp_Status: (state, param) => {
        const { payload } = param 
        const index = state.meetingdocspreparestatus.findIndex(
          (item:any) => item.resourceId === payload
        );
        if (index !== -1) {
          state.meetingdocspreparestatus.splice(index, 1);
        } 

      
      },




      cleare_update_DocsPrepareTemp_Status: (state) => {
        state.meetingdocspreparestatus = []
      },

      setsignprozess: (state, param) => {
        const { payload } = param
  
        
        if (payload.notarialErrorCode === undefined){
          let signprozessstatus = false
          if(payload.command === "signdoc"){
            signprozessstatus = true
            state.showsignmeetingdocs = payload
          } 
          if(payload.command === "cancelsigndoc"){
            signprozessstatus = false
            state.showsignmeetingdocs = []
          } 
          state.signprozess = signprozessstatus
        } else {
       
          notifications.show({
          title: intl.get('NOTIF_ERROR_HEADER'),
          message: intl.get('BackendServerResponseParseError'),
          withCloseButton: true,
          autoClose: false,
          color: 'red',
        })
      }
      },

      setsignprozessshared: (state, param) => {
        const { payload } = param

         //console.log("SHAREDSTAPEL_LINK_MAinslice",payload)
         

        if (payload.notarialErrorCode === undefined){
          let signprozessstatus = false
          
          if(payload.command === "opendoc"){
            state.temppdfurl = payload.sharedLink 
            state.temppdfurlresid = payload.resourceId      
            signprozessstatus = true
            state.accinProgress = "UTAB"
            state.showmeetingdocs = []
            state.readdocnotaronly = ""
           // state.showsignmeetingdocs = payload
          } 

            if(payload.command === "closedoc"){
            state.temppdfurl = ""
            state.temppdfurlresid = ""
            signprozessstatus = false
            state.isadhocsign = false
           // state.showsignmeetingdocs = payload
          }
          
          
          if(payload.command === "cancelsigndoc"){
            signprozessstatus = false
            state.showsignmeetingdocs = []
            state.isadhocsign = false
          } 
          state.signprozess = signprozessstatus
        } else {
       
          notifications.show({
          title: intl.get('NOTIF_ERROR_HEADER'),
          message: intl.get('BackendServerResponseParseError'),
          withCloseButton: true,
          autoClose: false,
          color: 'red',
        })
      }
      },

      setsignprozesssharedstapel: (state, param) => {
        const { payload } = param

        //console.log("SHAREDSTAPEL_LINK_MAinslice",payload)
        //console.log("LINK stapelSharedLink",payload.stapelSharedLink)

        if (payload.notarialErrorCode === undefined){
          let signprozessstatus = false
          
          if(payload.command === "opendoc"){
            state.temppdfurl = payload.stapelSharedLink 
            state.temppdfurlresid = payload.resourceId      
            signprozessstatus = true
            state.accinProgress = "UTAB"
            state.showmeetingdocs = []
            state.readdocnotaronly = ""
           // state.showsignmeetingdocs = payload
          } 

          //console.log("state.temppdfurl",state.temppdfurl)

            if(payload.command === "closedoc"){
            state.temppdfurl = ""
            state.temppdfurlresid = ""
            signprozessstatus = false
           // state.showsignmeetingdocs = payload
          }
           
          
          if(payload.command === "cancelsigndoc"){
            signprozessstatus = false
            state.showsignmeetingdocs = []
          } 
          state.signprozess = signprozessstatus
        } else {
       
          notifications.show({
          title: intl.get('NOTIF_ERROR_HEADER'),
          message: intl.get('BackendServerResponseParseError'),
          withCloseButton: true,
          autoClose: false,
          color: 'red',
        })
      }
      },

      cleare_setsignprozessshared: (state) => {
        state.temppdfurl = ""
        state.temppdfurlresid = ""
        state.accinProgress = ""
        
      },

      cleare_setsignprozessshared_fromdrn: (state, param) => {
        const { payload } = param

        console.log("cleare_setsignprozessshared_fromdrn",payload.meetingModel.meetingParticipants)
        state.meetinguser = payload.meetingModel.meetingParticipants
        state.meetingdocs = payload.meetingModel.documents

       
        //state.temppdfurl = ""
        //state.temppdfurlresid = ""
          if (state.accinProgress === "UTAB"){
        state.accinProgress = "UTAB"
          } else {
        state.accinProgress = ""
          }
        
        
      },

      cleare_setsignprozessshared_fromdrn_single: (state, param) => {
        const { payload } = param

        console.log("cleare_setsignprozessshared_fromdrn",payload.meetingModel.meetingParticipants)
        state.meetinguser = payload.meetingModel.meetingParticipants
        state.meetingdocs = payload.meetingModel.documents

        console.log("state.accinProgress",state.accinProgress)
        state.temppdfurl = ""
        state.temppdfurlresid = ""
          if (state.accinProgress === "UTAB"){
        state.accinProgress = "UTAB"
          } else {
        state.accinProgress = ""
          }
        
        
      },

      update_sharedsign_docstatus: (state,param) => {
        const { payload } = param
       // console.log("update_sharedsign_docstatus",payload)
        
        const updatesharedsigndoc:any = state.meetinguser.find((item:any) => item.id === payload.id)

        state.meetinguser = payload.meetingParticipants
     
        if (payload.notarialErrorCode === undefined){
        if (updatesharedsigndoc) {
          updatesharedsigndoc.documents = payload.documents
        }
      } else {
        notifications.show({
          title: intl.get('NOTIF_ERROR_HEADER'),
          message: intl.get('BackendServerResponseParseError'),
          withCloseButton: true,
          autoClose: false,
          color: 'red',
        })
      }
      },


      update_set_sigpreparestatus: (state, param) => {
        const { payload } = param

         const index = state.userhavetostapelsigndocs.findIndex(
          (item:any) => item.id === payload.id
        );
       if (index !== -1) {
        state.userhavetostapelsigndocs[index] = payload;
        //console.log("update",payload)
       }
      },






      setshowsplitdoc: (state, param) => {
        const { payload } = param
        console.log(payload)
        if(payload.command === "opendoc"){
          state.showmeetingdocs = payload
          state.readdocnotaronly = ""
          if (payload.guestDocumentOneTimeLink !== null) {
            state.guest_DocumentOneTimeLink = payload.guestDocumentOneTimeLink
          }
        } 
        if(payload.command === "closedoc"){
          state.showmeetingdocs = []
          state.guest_DocumentOneTimeLink = null
        }  
      },

      // empty when no Action in Accordion is underway
      set_Acc_InProgress: (state, param) => {
        const { payload } = param
        state.accinProgress = payload
      },

      // clear Action when no user is login
      clear_Acc_InProgress: (state) => {
          state.accinProgress = ""
          state.activconfirmuser = ""
      },

      
      // Scrennshots - get init Daten (wenn es welche in der DB gibt)
      get_init_screenshotdata: (state, param) => {
        const { payload } = param
        state.identscreenshots = payload
      },

      set_get_screenshot:(state) => {
        state.startscreenshot = true
      },

     store_screenshots: (state, param) => {
      const { payload } = param
      const isscreenshot:any = state.identscreenshots.find((item:any) => item.id === payload.id)
      if (!isscreenshot && payload.id !== null) {
      state.identscreenshots.push(payload)
      state.newscreenshot = true
      state.newscreenshotid = payload.userParticipantId
      state.startscreenshot = false
      }

      if (!isscreenshot && payload.id === null) {
        console.log(payload)
        state.screeshoterror = payload.description
        }
      },

     remove_screenshot: (state, param) => {
      const { payload } = param
      console.log(payload)
      const isscreenshot:any = state.identscreenshots.find((item:any) => item.id === payload.id)
      if (isscreenshot) {
      state.identscreenshots.splice(state.identscreenshots.findIndex((item:any) => item.id === payload.id), 1);
      state.newscreenshot = false
      }
     }, 
     
     clear_screenshoterror: (state) => {
      state.screeshoterror = ""
      state.newscreenshotid = ""
      state.startscreenshot = false
     },

     clear_newscreenshot: (state) => {
      state.newscreenshot = false
     },

     // User Have to Sign Docs
     setup_user_todocs: (state, param) => {
      const { payload } = param
      //console.log(payload)
      const index = state.userhavetosigndocs.findIndex(
        (item:any) => item.resourceId === payload.resourceId
      );

      if (index !== -1) {
        if (payload.user.length === 0) {
          // Remove the item if the user array is empty
          state.userhavetosigndocs.splice(index, 1);
          const newLength = state.userhavetosigndocs.length;
          if (newLength === 0) {
            state.meetingdocspreparestatus = [];
          }
          
        } else {
          // Update the item if the user array is not empty
          state.userhavetosigndocs[index] = payload;
        }
      } else {
        // Add the item if it doesn't exist and the user array is not empty
        if (payload.user.length !== 0) {
          state.userhavetosigndocs.push(payload);
        }
      }

     },

     update_localdoc_signstate: (state, param) => {
      const { payload } = param
     // console.log(payload)
     // console.log(current(state.meetingdocs))
      // Extend to update meetigdocs local store temporär
      const docindex = state.meetingdocs.findIndex(
        (item:any) => item.resourceId === payload.resourceId
      );
      if (docindex !== -1) {
        state.meetingdocs[docindex].isToBeSigned = payload.isToBeSigned
      }

     },

     update_localdoc_readstate: (state, param) => {
      const { payload } = param
      const docindex = state.meetingdocs.findIndex(
        (item:any) => item.resourceId === payload.resourceId
      );
      if (docindex !== -1) {
        state.meetingdocs[docindex].isToBeRead = payload.isToBeRead
      }
     },

     remove_user_todocs: (state, param) => {
      const { payload } = param
     // console.log(payload)
      const index = state.userhavetosigndocs.findIndex(
        (item:any) => item.resourceId === payload.resourceId
      );

      if (index !== -1) {
        // Access the user array of the matched resourceId
        const user = state.userhavetosigndocs[index];
    
        // Filter out the payload.userId from the user array
        user.user = user.user.filter((userId: any) => userId !== payload.userId);
    
        // Remove the entire resource entry if no users remain
        if (user.user.length === 0) {
          state.userhavetosigndocs.splice(index, 1);
        }
      }

     },


     
setup_user_stapeltodocs: (state, action) => {
  const payload = action.payload;

  // 🔑 eindeutig identifizieren
  const index = state.userhavetostapelsigndocs.findIndex((item: any) => {
    if (payload.stapelId && item.stapelId) {
      return item.stapelId === payload.stapelId;
    }
    if (payload.localStapelId && item.localStapelId) {
      return item.localStapelId === payload.localStapelId;
    }
    return false;
  });

  if (index !== -1) {
    // UPDATE
    if (!payload.documentsSignModes || payload.documentsSignModes.length === 0) {
      state.userhavetostapelsigndocs.splice(index, 1);
    } else {
      state.userhavetostapelsigndocs[index] = {
        ...state.userhavetostapelsigndocs[index],
        ...payload,
        documentsSignModes: payload.documentsSignModes,
      };
    }
  } else {
    // CREATE
    if (payload.documentsSignModes && payload.documentsSignModes.length > 0) {
      state.userhavetostapelsigndocs.push({
        ...payload,
        documentsSignModes: payload.documentsSignModes,
      });
    }
  }

  state.userhavechangestapel = false;
},

     
     get_user_stapeltodocs_frombackend: (state, param) => {
      const { payload } = param
        if (payload.notarialErrorCode === undefined){
      state.userhavetostapelsigndocs = payload;
      state.userhavechangestapel = false
      } else {
        notifications.show({
          title: payload.notarialErrorCode,
          message: payload.description,
          withCloseButton: false,
          autoClose: 4000,
          color: 'red',
          })
          state.playsound = true
      }
     },


     update_user_stapeltodocs_frombackend: (state, param) => {
      const { payload } = param
      //console.log(payload)
      if (payload.notarialErrorCode === undefined){

        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        const index = state.userhavetostapelsigndocs.findIndex((item: { id: any; }) => item.id === payload.id);
        
        if (index !== -1) {
          state.userhavetostapelsigndocs[index] = {
            ...state.userhavetostapelsigndocs[index],
            ...payload,
          };
        }

        } else {
          notifications.show({
            title: payload.notarialErrorCode,
            message: payload.description,
            withCloseButton: false,
            autoClose: 4000,
            color: 'red',
            })
            state.playsound = true
        }
       },
     

     set_changein_userstapel: (state,param) => {
      const { payload } = param
      state.userhavechangestapel = payload;
     },

     
setup_user_stapeltodocs_delete_doc: (state, action) => {
  const { resourceId, stapelId, localStapelId } = action.payload;
console.log(action.payload)
  const index = state.userhavetostapelsigndocs.findIndex((item: any) => {
    // 🔑 Backend-Stapel hat Priorität
    if (stapelId && item.id) {
      return item.id === stapelId;
    }
    // 🔑 UI-Stapel
    if (localStapelId && item.localStapelId) {
      return item.localStapelId === localStapelId;
    }
    return false;
  });

  if (index === -1) return;

  const stapel = state.userhavetostapelsigndocs[index];

  stapel.documentsSignModes = stapel.documentsSignModes.filter(
    (doc: any) => doc.resourceId !== resourceId
  );

  // 🔥 Stapel komplett leer → entfernen
  if (stapel.documentsSignModes.length === 0) {
    state.userhavetostapelsigndocs.splice(index, 1);
  }
},


remove_doc_from_all_stapels: (state, action) => {
  const { resourceId } = action.payload;
  state.userhavetostapelsigndocs = state.userhavetostapelsigndocs
    .map((stapel: any) => {
      if (!stapel.documentsSignModes) return stapel;
      return {
        ...stapel,
        documentsSignModes: stapel.documentsSignModes.filter(
          (doc: any) => doc.resourceId !== resourceId
        ),
      };
    })
    .filter((stapel: any) => !stapel.documentsSignModes || stapel.documentsSignModes.length > 0);

    
},


  setup_user_stapeltodocs_delete_editdoc: (state, param) => {
      const { payload } = param
      const index = state.userhavetostapelsigndocs.findIndex(
        (item:any) => item.participantId === payload.participantId
      );

      //console.log(current(state.userhavetostapelsigndocs[index]))

      if (index !== -1) {
        const docs = state.userhavetostapelsigndocs[index];
        // Filter out the resourceId from stapeldocs
        docs.stapelResourceIds = docs.stapelResourceIds.filter((docId: any) => docId === payload.stapelResourceIds);
        console.log(current(docs))
        if (docs.stapelResourceIds.length === 0) {
          console.log("Hot Splice")
          state.userhavetostapelsigndocs.splice(index, 1);
        }
      }
     },



     setuphelp_userhavetoident: (state, param) => {
      const { payload } = param
      state.userhavetoident = payload
     },

     clear_userhavetoident: (state) => {
      state.userhavetoident = []
     },

     update_meetinguser_aftersetident: (state, param) => {
      const { payload } = param
      state.meetinguser = payload
     },

     set_updatemeeting: (state ) => {
      state.updatemeetingdate = true;  

      notifications.show({
        title: intl.get('NOTIF_INFO_SUCCSES'),
        message: intl.get('NOTIF_UPDATE_TERM'),
        withCloseButton: false,
        autoClose: 5000,
        color: 'green',
      })
     },

     unset_updatemeeting: (state ) => {
      state.updatemeetingdate = false;  
     },
  
     set_meetinglogs: (state, param) => { 
      const { payload } = param
      //console.log(payload)
      state.meetinglogs = payload; 

     },

     set_showmeeting: (state) => {
      state.showlogs = !state.showlogs
     },

     unset_showmeeting: (state) => {
      state.showlogs = false
     },

     set_close_setup: (state) => {
      state.setupnotar = false
     },

     set_notarhastosign: (state, param) => {
      const { payload } = param
      state.notarhastosign = payload
     },

     
     set_klientidAustriaaccept: (state, param) => {
      const { payload } = param
      const isacceptonklient:any = state.klientidAustriaaccept.find((item:any) => item.meetingParticipantId === payload.meetingParticipantId)
      if (!isacceptonklient && payload.meetingParticipantId !== null) {
        state.klientidAustriaaccept.push(payload)
      }
     },



     set_idaustriadataloading: (state, param) => {
      const { payload } = param
     // console.log(payload)
      const isloading:any = state.idAustriadataloading.find((item:any) => item.meetingParticipantId === payload.meetingParticipantId)
      if (!isloading && payload.meetingParticipantId !== null) {
       state.idAustriadataloading.push(payload)
      }
     },

     remove_idaustriadataloading: (state, param) => {
      const { payload } = param
      const index = state.idAustriadataloading.findIndex(
        (item: { meetingParticipantId: any; }) => item.meetingParticipantId === payload.meetingParticipantId
      );
      if (index !== -1) {
        state.idAustriadataloading.splice(index, 1);
      }
     },



     remove_klientidAustriaaccept: (state, param) => {
      const { payload } = param
      const index = state.idAustriadataloading.findIndex(
        (item: { meetingParticipantId: any; }) => item.meetingParticipantId === payload.meetingParticipantId
      );
      if (index !== -1) {
        state.idAustriadataloading.splice(index, 1);
      }

      const index1 = state.klientidAustriaaccept.findIndex(
        (item: { meetingParticipantId: any; }) => item.meetingParticipantId === payload.meetingParticipantId
      );
      if (index1 !== -1) {
        state.klientidAustriaaccept.splice(index1, 1);
      }

     },

     set_idaustriachachedata: (state, param) => {
      const { payload } = param
      state.idAustriadata = payload
     },


     set_idaustriadata: (state, param) => {
      const { payload } = param
    //  console.log(payload.participantModel.id)
    //  console.log(current(state.idAustriadata))
      const idadata = state.idAustriadata.findIndex((item:any) => item.id === payload.id)
     // console.log(idadata)
      if (idadata !== undefined) {
        // console.log(idadata)
      } else {
        console.log("Not idadata foung -> push")
      }
      if (idadata === -1 && payload.participantModel.id !== null) {
        state.idAustriadata.push(payload)
      }

      const index1 = state.klientidAustriaaccept.findIndex(
        (item: { meetingParticipantId: any; }) => item.meetingParticipantId === payload.participantModel.id
      );
      if (index1 !== -1) {
        state.klientidAustriaaccept.splice(index1, 1);
      }

      const index = state.idAustriadataloading.findIndex(
        (item: { meetingParticipantId: any; }) => item.meetingParticipantId === payload.participantModel.id
      );
      if (index !== -1) {
        state.idAustriadataloading.splice(index, 1);
      }


     },

     clearidaustria_data: (state,param) => {
      
      const { payload } = param
      //console.log("clearidaustria_data ->" + payload)
      const index:any = state.idAustriadata.find((item:any) => item.participantModel.meetingParticipantId === payload)
      if (index !== undefined) {
        console.log(current(index))
      }
      if (index !== -1) {
        state.idAustriadata.splice(index, 1);
      }
      
     },

     
     update_confirm_idaustriadata: (state, param) => {
      const { payload } = param
     // console.log(payload)
      const updateidaustriadata:any = state.meetinguser.find((item:any) => item.id === payload.id)
      if (updateidaustriadata) {
        updateidaustriadata.idAustriaData = payload.idAustriaData
      }
     // console.log(current(updateuseractiondata))
    },

    /**
     * Updates the participants Alias Name in the state based on the payload.
     *
     * @param {object} state - The current state object.
     * @param {object} param - The parameter object containing the payload.
     * @param {object} param.payload - The payload object containing the meetingParticipants.
     * @param {string} param.payload.notarialErrorCode - The error code, if any.
     * @param {array} param.payload.meetingParticipants - The array of meeting participants.
     * @return {void}
     */
    update_participants: (state,param) => {
        const { payload } = param
        if (payload.notarialErrorCode === undefined){ 
          state.meetinguser = payload.meetingParticipants
          let notarid = state.meuser.userId
          const updatedMeUser = payload.meetingParticipants.find((participant: { userId: any; }) => participant.userId === notarid);
          if (updatedMeUser) {
            state.meuser = updatedMeUser;
          } 
    } else {  
        notifications.show({
        title: intl.get('NOTIF_ERROR_HEADER'),
        message: intl.get('BackendServerUnavailable'),
        withCloseButton: true,
        autoClose: false,
        color: 'red',
    })
  }
    },

    set_docstoconvert: (state,param) => {
      const { payload } = param
      state.docsconvertinprogress = payload
    },

    
    /**
     * Flag um das externe schliessen des Client im DRN (X) zu signaliesieren.
     *
     * @param {object} state - The current state object.
     * @param {object} param - The parameter object containing the payload.
     * @param {any} param.payload - The payload value to be assigned to the 'externclosevk' property.
     * @return {void} This function does not return anything.
     */
    close_vk_extern: (state,param) => {
      const { payload } = param
      console.log(payload.isToClose)
      state.externclosevk = payload.isToClose
    },

    /**
     * Setzt die Flag zum öffnen des Fensters zurück
     *
     */

    close_vk_extern_modal: (state) => {
      state.externclosevk = false
    },

    update_docstoconvert: (state,param) => {
      const { payload } = param
     // console.log(payload)
      if(payload.notarialErrorMessage === null){
        console.log(current(state.docsconvertinprogress))
        const index:any = state.docsconvertinprogress.find((item:any) => item.resourceId === payload.documentResourceId)
        if (index !== -1) {
          state.docsconvertinprogress.splice(index, 1);
        }
        
      const index1:any = state.meetingdocs.findIndex((item:any) => item.resourceId === payload.documentResourceId)
      if (index1 !== -1) {
        //console.log(current(state.meetingdocs[index1]))
        state.meetingdocs[index1].isPDFA1b = payload.isConverted
      }

      }
      if(payload.notarialErrorMessage !== null){
        const index:any = state.docsconvertinprogress.findIndex((item:any) => item.resourceId === payload.documentResourceId)
        if (index !== -1) {
          console.log(payload.notarialErrorMessage.notarialErrorCode)
          state.docsconvertinprogress[index].error = payload.notarialErrorMessage.notarialErrorCode
        }
        
      }
    },
    
        /**
     * State of Sent and Recive Data for Setup for Sig Block settings in DRN.
     *
     * @param {object} state - The current state object.
     * @param {object} param - An object containing the payload to update the state with.
     * @param {any} param.payload - The new value for the `usertosignsent` property.
     * @return {void} This function does not return anything.
     */
    set_usertosignsent: (state,param) => {
      const { payload } = param
      //console.log(payload)
      //console.log(payload.isTrue)
      state.usertosignsent = payload.isTrue  

    },

    clear_usertosignsent: (state) => {
      state.usertosignsent = false  

    },


    update_SetDoc_Sigblock: (state, param) => {
      const { payload } = param
      //console.log(payload.documents)
      //state.meetingdocs = payload.documents
      //console.log(state.leftmeeting)
 
      payload.documents.forEach((payloadDoc: { resourceId: any; isSigPrepared: any; }) => {
        // 2. Find the corresponding document in the state array
       // console.log(payloadDoc.resourceId)
        
        const docInState = state.meetingdocs.find(
          (stateDoc: { resourceId: any; }) => stateDoc.resourceId === payloadDoc.resourceId
          
        );
       // console.log(current(docInState))
        if (docInState) {
            // Because Redux Toolkit uses Immer, this direct mutation is safe
            // and automatically produces a new immutable state.
            docInState.isSigPrepared = payloadDoc.isSigPrepared;
            if (payloadDoc.isSigPrepared === true){
             docInState.isToBeSigned = true;
            }
        }
    });



    },

    update_DeleteDoc_Sigblock: (state, param) => {
      const { payload } = param
      //console.log(payload)
     const updateuserdocumentsdata:any = state.meetingdocs.find((item:any) => item.resourceId === payload.resourceId)
    // console.log(current(updateuserdocumentsdata))
     if (updateuserdocumentsdata) {
       updateuserdocumentsdata.isSigPrepared = false
     }
    },


    // Guest User Functions
    // Kickuser if Notar delete User in DRN but User is already online
    kickuser: (state: Record<string, any>, param) => {
      const { payload } = param
      state.iskicked = payload.isDeleted
      console.log(payload.isDeleted)

       // Reset all other state properties to their initial values
        Object.keys(state).forEach(key => {
          if (key !== 'iskicked' && key !== 'clientlanguage') {
            if (Array.isArray(state[key])) {
              state[key] = [];
            } else if (typeof state[key] === 'object' && state[key] !== null) {
              state[key] = {};
            } else if (typeof state[key] === 'string') {
              state[key] = '';
            } else if (typeof state[key] === 'number') {
              state[key] = 0;
            } else if (typeof state[key] === 'boolean') {
              state[key] = false;
            } else {
              state[key] = null; // Default reset for other types
            }
          }
        });
    },


    getadduseriframelink: (state, param) => {
      const { payload } = param
      console.log(payload.videoConferenceSettingsUrl)
      state.adduseriframelink = payload.videoConferenceSettingsUrl
    },


    /**
     * Zum schliessen der VK den joinlink auf empty setzten
     *
     * @param {object} state - The current state object.
     */
    guest_close_vk_extern: (state) => {
      state.guest_joinlink = []
      state.guest_leftmeeting = true
    },

        /**
     * Guest received confirm am me Data when identified via hash.
     *
     * @param {object} state - The current state of the application.
     * @param {object} param - The parameter object containing the payload.
     * @param {any} param.payload - The payload received in the action.
     * @return {void} This function does not return anything.
     */
    guest_recive_hashconfirmdata: (state, param) => {
      const { payload } = param
      //console.log(payload)
      if (payload.notarialErrorCode === null){ 
      state.guest_meinfo = payload.me
      state.guest_isValid = payload.isValid

      notifications.show({
        title: intl.get('GUESTDASH_HASHWRONG_HEAD_OK'),
        message: intl.get('GUESTDASH_HASHWRONG_CONTENT_OK'),
        withCloseButton: false,
        autoClose: 1000,
        color: 'green',
        })


      } else {  
        
        state.guest_isValid = false
        notifications.show({
        title: intl.get('GUESTDASH_HASHWRONG_HEAD'),
        message: intl.get('GUESTDASH_HASHWRONG_CONTENT'),
        withCloseButton: true,
        autoClose: false,
        color: 'red',
        })
    }
    },

   /*
    * Guest received Meeting Data when identified via hash.
    *
    * @param {object} state - The current state of the application.
    * @param {object} param - The parameter object containing the payload.
    * @param {any} param.payload - The payload received in the action.
    * @return {void} This function does not return anything.
    */
   guest_recive_meetingdata: (state, param) => {
     const { payload } = param
     //console.log(payload.gastMeetingData.gastMeetingParticipants)
     
     if (payload.notarialErrorCode === null){ 
     state.guest_meetinginfo = payload.gastMeetingData
     state.guest_meeting_participants = payload.gastMeetingData.gastMeetingParticipants

     let checknotarstate = payload.gastMeetingData.gastMeetingParticipants.filter((obj: { role: any; }) => {
      return obj.role === "notar" 
     });
     //console.log(checknotarstate[0].meetingParticipantStatus)

     if (checknotarstate[0].meetingParticipantStatus === "InMeeting"){
      state.hostforguestisonline = true
     }
  } else if (payload.notarialErrorCode !== null) {  
      state.guest_already_inmeeting = true
      state.guest_isValid = false
      notifications.show({
        title: payload.notarialErrorCode,
        message: payload.ParticipantIsAlreadyinMeeting,
        withCloseButton: true,
        autoClose: false,
        color: 'red',
        })
    }

   },

   guest_updateparticipantsData: (state, param) => {
    const { payload } = param
    //console.log(payload)
    state.guest_meeting_participants = payload.gastMeetingParticipants
   },
    

   /*
    * Guest received Joinlink Data when requested.
    *
    * @param {object} param - The parameter object containing the payload.
    * @param {any} param.payload - The payload received in the action.
    * @return {void} This function does not return anything.
    */
   guest_recive_joinlinkdata: (state, param) => {
    const { payload } = param
    //console.log(payload)
    if (payload.notarialErrorCode === undefined){ 
    state.guest_joinlink = payload
    state.hostforguestisonline = payload.isNotarInMeeting
    state.guest_notarleftmeeting = false
    state.guest_documents = payload.documentsGuestModel
    } else {  
      //state.guest_notarleftmeeting = true
      if (payload.notarialErrorCode === "AccessDenied") {
        state.guest_accsses_denied = true
      }
     
      notifications.show({
        title: payload.notarialErrorCode,
        message: intl.get(payload.notarialErrorCode),
        withCloseButton: true,
        autoClose: false,
        color: 'red',
        })

       
    }
  },

     /*
    * Guest received information that Notar is online.
    *
    * @param {object} param - The parameter object containing the payload.
    * @param {any} param.payload - The payload received in the action.
    * @return {void} This function does not return anything.
    */
     guest_recive_notarnotification: (state, param) => {
      const { payload } = param
     // console.log(payload)
      state.hostforguestisonline = payload.isNotarInMeeting
    },

    
    guest_update_UserData: (state, param) => {
      const { payload } = param
    //console.log(payload)
      const updateuserdata:any = state.guest_meeting_participants.find((item:any) => item.id === payload.id)

      const [username, domain] = payload.userId.split('@')[0]
      const initials = username[0].toUpperCase() + domain[0].toUpperCase();
      // Update Guest User participants
      if (updateuserdata && state.guest_leftmeeting === false) {


        
        if (payload.meetingParticipantStatus === "LeftMeeting" && updateuserdata.meetingParticipantStatus !== "LeftMeeting") {
          notifications.show({
            title: intl.get('GUESTMESSAGE_LEFTMEETING_HEAD'),
            message:  initials + ' ' + intl.get('GUESTMESSAGE_LEFTMEETING_CONTENT'),
            withCloseButton: false,
            autoClose: 4000,
            color: 'red',
            })
            // Trigger if Notar left Meeting update Store
            if (updateuserdata.role === "notar") {
              //state.guest_notarleftmeeting = true
              //state.hostforguestisonline = false
            }

        }

        if (payload.meetingParticipantStatus === "InMeeting" && updateuserdata.meetingParticipantStatus !== "InMeeting") {
          notifications.show({
            title: intl.get('GUESTMESSAGE_JOINMEETING_HEAD'),
            message: initials + ' ' + updateuserdata.lastName + ' ' + intl.get('GUESTMESSAGE_JOINMEETING_CONTENT'),
            withCloseButton: false,
            autoClose: 3000,
            color: 'green',
            })
            // Trigger if Notar left Meeting update Store
        }

        updateuserdata.meetingParticipantStatus = payload.meetingParticipantStatus


      }
    },


    guest_update_Meeting_UserStatus: (state, param) => {
      const { payload } = param
      if (payload.meetingParticipantStatus === "LeftMeeting" && state.guest_meinfo.id === payload.id ) {
          state.guest_meinfo.meetingParticipantStatus = payload.meetingParticipantStatus
          state.guest_leftmeeting = true
          state.guest_joinlink = []  
       }
      //console.log(current(state.guest_joinlink))
    },


    guest_update_InviteGuestforVK: (state, param) => {
      const { payload } = param
       //console.log(payload)

     if (payload.notarialErrorCode === undefined){

      const updateinviteuserdata:any = state.guest_meeting_participants.find((item:any) => item.id === payload.id)
      //console.log( current(updateinviteuserdata))


      const [username, domain] = payload.userId.split('@')[0]
      const initials = username[0].toUpperCase() + domain[0].toUpperCase();

   

      if (!updateinviteuserdata) {
        // If user doesn't exist, add them to meetinguser array
         state.guest_meeting_participants.push(payload);

         notifications.show({
          title: intl.get('GUESTMESSAGE_JOINMEETING_HEAD'),
          message: initials + " wurde in das Meeting aufgenommen",
          withCloseButton: false,
          autoClose: 3000,
          color: 'green',
          })
          state.playsound = true
      }
     } else {
      notifications.show({
        title: intl.get('GUESTMESSAGE_LEFTMEETING_HEAD'),
        message: payload.description,
        withCloseButton: false,
        autoClose: 4000,
        color: 'red',
        })
        state.playsound = true 
     }
    },


    guest_remove_InviteGuestforVK: (state, param) => {
      const { payload } = param
      console.log(payload)
     // const updateinviteuserdata:any = state.meetinguser.find((item:any) => item.id === payload.id)
      const userIndex = state.guest_meeting_participants.findIndex((item: any) => item.id === payload.id);
      //console.log( current(updateinviteuserdata))

      const [username, domain] = payload.userId.split('@')[0]
      const initials = username[0].toUpperCase() + domain[0].toUpperCase();

      if (userIndex !== -1) {
        state.guest_has_removed = true;
        state.guest_meeting_participants.splice(userIndex, 1); 
        notifications.show({
          title: intl.get('GUESTMESSAGE_LEFTMEETING_HEAD'),
          message: initials + " wurde als Gast aus dem Meeting entfernt",
          withCloseButton: false,
          autoClose: 3000,
          color: 'green',
          })
          state.playsound = true
      } else {
        // If user doesn't exist, add them to meetinguser array
         notifications.show({
          title: intl.get('GUESTMESSAGE_JOINMEETING_HEAD'),
          message: initials + " wurde nicht in der Gastliste gefunden",
          withCloseButton: false,
          autoClose: 4000,
          color: 'red',
          })
          state.playsound = true
      }
    },

    display_active_tab_message: (state, param) => {
      const { payload } = param
      
      if(payload.notarialErrorCode !== undefined){
        notifications.show({
         title: "Aktiver Tab oder Fenster",
         message: payload.description,
         withCloseButton: false,
         autoClose: 3000,
         color: 'green',
         })
       }
    },

    guest_set_notactivetab: (state, param) => {
      const { payload } = param
      
      if (payload.notarialErrorCode !== undefined){   
          //state.guest_notarleftmeeting = true
          notifications.show({
            title: payload.notarialErrorCode,
            message: payload.description,
            withCloseButton: true,
            autoClose: false,
            color: 'red',
            })
          state.guest_notactive = true
          state.guest_meetinginfo = []
          state.guest_meeting_participants = []
          state.guest_meinfo = []
          state.guest_isValid = false
        }
      //console.log(state.leftmeeting)
    },

  
    guest_display_reinvite: (state, param) => {
      const { payload } = param
      
      if (payload.NotarialErrorMessage === undefined){   
        notifications.show({
          title: "Reinvite Mail versand!",
          message:'Reinvite Mail an ' + payload.emailAddress + 'wurde erfolgreich versandt',
          withCloseButton: false,
          autoClose: 3000,
          color: 'green',
          })
        } else {
          notifications.show({
            title: "Fehler bei Mail Versand!",
            message: 'Reinvite Mail an ' + payload.emailAddress + 'konnte nicht versandt werden',
            withCloseButton: true,
            autoClose: false,
            color: 'red',
            })
        }
      //console.log(state.leftmeeting)
    },



    clear_playsound: (state) => {
      state.playsound = false
    },

    set_userclick: (state) => {
      state.help_audio_clicked = true
    },


    // Setzten und Löschen der Daten für den Testclient 
    set_testdata: (state, param) => {
      const { payload } = param
      state.test_data = payload;
    },

    clear_testdata: (state) => {
      state.test_data = [];
    },

    set_userleave_cms: (state,param) => {
      const { payload } = param
      console.log(payload)
      state.test_userleave_cms = true
      state.test_data.link = null;
    },

  

     /*
    * Guest received Joinlink Data when requested.
    *
    * @param {object} param - The parameter object containing the payload.
    * @param {any} param.payload - The payload received in the action.
    * @return {void} This function does not return anything.
    */
     meeting_closed_error: (state, param) => {
      const { payload } = param
      if (payload.notarialErrorCode !== undefined){
        state.meetingclosed = true
        state.cmslink = [];
        notifications.show({
          title: intl.get('NOTIF_ERROR_HEADER'),
          message: intl.get('NOTIF_ERROR_MEETINGCLOSED'),
          withCloseButton: true,
          autoClose: false,
          color: 'red',
      })
      }
    },





    },
  });

export const {
  connect,
  guestconnect,
  connecterror,
  disconnect,
  gettoken,
  setsetupnotar,
  handleonlinebar,
  setclientlanguage,
  clear_setclientlanguage,
  set_close_setup,
  setdisplaytyp,
  setszenetyp,
  setusertype,
  setdisplaywidth,
  setcmslink,
  updatedataonchangeinDRN,
  setrejoincmslink,
  setactiveconfirmuser,
  clearactiveconfirmuser,
  update_UserData,
  update_InviteGuestforVK,
  remove_InviteGuestforVK,
  update_confirm_UserData,
  update_Meeting_UserStatus,
  update_Docs_Status,
  update_localdoc_signstate,
  update_localdoc_readstate,
  refresh_Docs,
  refresh_Docs_onUpdate,
  refresh_Docs_onUpdate_CloseModal,
  update_SetDoc_Readout,
  update_DocsSign_Status,
  update_DocsSignStapel_Status,
  update_Prepare_Docs,
  update_DocsPrepareTemp_Status,
  remove_DocsPrepareTemp_Status,
  cleare_update_DocsPrepareTemp_Status,
  update_SetDoc_isSignedByAll,
  setsignprozess,
  setsignprozessshared,
  setsignprozesssharedstapel,
  cleare_setsignprozessshared,
  setshowsplitdoc,
  set_Acc_InProgress,
  clear_Acc_InProgress,
  get_init_screenshotdata,
  set_get_screenshot,
  store_screenshots,
  remove_screenshot,
  clear_newscreenshot,
  setup_user_todocs,
  remove_user_todocs,
  setup_user_stapeltodocs,
  setup_user_stapeltodocs_delete_doc,
  setup_user_stapeltodocs_delete_editdoc,
  remove_doc_from_all_stapels,
  get_user_stapeltodocs_frombackend,
  update_user_stapeltodocs_frombackend,
  set_updatemeeting,
  unset_updatemeeting,
  set_meetinglogs,
  set_showmeeting,
  unset_showmeeting,
  set_notarhastosign,
  set_idaustriadataloading,
  set_klientidAustriaaccept,
  remove_idaustriadataloading,
  remove_klientidAustriaaccept,
  set_idaustriadata,
  set_idaustriachachedata,
  clear_screenshoterror,
  update_confirm_idaustriadata,
  clearidaustria_data,
  update_participants,
  set_docstoconvert,
  update_docstoconvert,
  setuphelp_userhavetoident,
  clear_userhavetoident,
  update_meetinguser_aftersetident,
  close_vk_extern,
  close_vk_extern_modal,
  set_usertosignsent,
  clear_usertosignsent,
  update_SetDoc_Sigblock,
  update_DeleteDoc_Sigblock,
  guest_close_vk_extern,
  guest_recive_hashconfirmdata,
  guest_recive_meetingdata,
  guest_recive_joinlinkdata,
  meeting_closed_error,
  guest_recive_notarnotification,
  guest_update_UserData,
  guest_update_Meeting_UserStatus,
  guest_update_InviteGuestforVK,
  guest_remove_InviteGuestforVK,
  display_active_tab_message,
  guest_set_notactivetab,
  guest_display_reinvite,
  guest_updateparticipantsData,
  clear_playsound,
  set_testdata,
  set_userleave_cms,
  clear_testdata,
  set_userclick,
  set_changein_userstapel,
  kickuser,
  set_signtabopen,
  clear_signtabopen,
  read_doc_notaronly,
  update_sharedsign_docstatus,
  clear_read_doc_notaronly,
  set_signisstapel,
  clear_signisstapel,
  cleare_setsignprozessshared_fromdrn,
  cleare_setsignprozessshared_fromdrn_single,
  set_isadhocsign,
  update_set_sigpreparestatus,
  set_modal_stapel_setup_open,
  getadduseriframelink,
  } = mainSlice.actions
export default mainSlice.reducer

